import { relationship } from "@/mocks/manga";

const nodeColor: Record<string, string> = {
  primary: "border-primary-300 bg-primary-100 text-primary-900",
  accent: "border-accent-300 bg-accent-100 text-accent-900",
  secondary: "border-secondary-300 bg-secondary-100 text-secondary-900",
};

export default function Relationship() {
  return (
    <section id="relationship" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <p className="mb-3 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-500">
            <span className="h-px w-8 bg-primary-400" aria-hidden="true"></span>
            角色关系图谱
            <span className="h-px w-8 bg-primary-400" aria-hidden="true"></span>
          </p>
          <h2 className="font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            一张图看懂 <span className="text-primary-600">角色关系</span> 与CP走向
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-700">
            把主线CP、守护线、闺蜜线与系统线拆成清晰的组团关系，新老读者都能快速锁定喜欢的角色与配对。
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {relationship.map((group) => (
            <div
              key={group.group}
              className="rounded-2xl border border-background-200/80 bg-background-100 p-6"
            >
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
                  <i className="ri-node-tree text-sm" aria-hidden="true"></i>
                </span>
                {group.group}
              </h3>

              <div className="mt-5 flex flex-wrap items-center gap-2">
                {group.nodes.map((n) => (
                  <span
                    key={n.name}
                    className={`flex items-center gap-1.5 rounded-full border px-3.5 py-1.5 text-sm font-medium ${nodeColor[n.color]}`}
                  >
                    {n.name}
                    <em className="not-italic text-xs opacity-70">({n.note})</em>
                  </span>
                ))}
              </div>

              <div className="mt-5 space-y-2.5 border-t border-dashed border-background-300 pt-4">
                {group.lines.map((line) => (
                  <div
                    key={`${line.a}-${line.b}`}
                    className="flex flex-wrap items-center gap-2 text-sm"
                  >
                    <span className="font-medium text-foreground-800">{line.a}</span>
                    <span
                      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium ${
                        line.kind === "strong"
                          ? "bg-primary-100 text-primary-700"
                          : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      <i
                        className={line.kind === "strong" ? "ri-heart-2-fill" : "ri-arrow-right-line"}
                        aria-hidden="true"
                      ></i>
                      {line.text}
                    </span>
                    <span className="font-medium text-foreground-800">{line.b}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}